import React from 'react';
import { Button } from 'reactstrap';
import { Translate, ValidatedField } from 'react-jhipster';
import { IQuotation } from 'app/shared/model/quotation.model';
import { isEditable } from 'app/shared/util/quotation-utils';

interface TransactionRefNoDisplayButtonProps {
  transactionRefNo: string;
  quotationEntity?: IQuotation;
  handleTransactionModal: (mode: 'ADDING-LATE' | 'EDIT') => void;
}

const TransactionRefNoDisplayButton: React.FC<TransactionRefNoDisplayButtonProps> = ({
  transactionRefNo,
  quotationEntity,
  handleTransactionModal,
}) => {
  const maxEditableDays = quotationEntity?.bank?.quotationMaxEditableDays;
  const createdDate = quotationEntity?.createdDate ? new Date(quotationEntity.createdDate) : null;
  const currentDate = new Date();

  if (!quotationEntity?.transactionRefNo) {
    return (
      <Button
        color="link"
        className="px-1"
        style={{ fontSize: '11px', padding: '0 4px' }}
        onClick={() => handleTransactionModal('ADDING-LATE')}
      >
        <Translate contentKey="comexApp.quotation.addTransactionRefNo">ADD TRANSACTION REFERENCE NUMBER</Translate>
      </Button>
    );
  }

  return (
    <div>
      <ValidatedField
        id="transactionRefNo"
        name="transactionRefNo"
        data-cy="transactionRefNo"
        disabled
        value={quotationEntity?.transactionRefNo}
      />
      <Button
        color="link"
        className="px-1 mt-1"
        style={{ fontSize: '11px', padding: '0 4px' }}
        onClick={() => handleTransactionModal('EDIT')}
        disabled={!isEditable(createdDate, maxEditableDays, currentDate)}
      >
        <Translate contentKey="comexApp.quotation.editTransactionRefNo">EDIT TRANSACTION REFERENCE NUMBER</Translate>
      </Button>
    </div>
  );
};

export default TransactionRefNoDisplayButton;
